import { render, staticRenderFns } from "./LocalisationEventsMobileModal.vue?vue&type=template&id=416096ba&"
import script from "./LocalisationEventsMobileModal.vue?vue&type=script&lang=ts&"
export * from "./LocalisationEventsMobileModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports